import React from "react";
import styles from "../Home/Award/Award.module.scss";

interface AwardsCardProps {
  awardImage: string;
  description: string;
}

const AwardsCard: React.FC<AwardsCardProps> = ({ awardImage, description }) => {
  return (
    <div
      className={`${styles.awardCardDiv} d-flex flex-column justify-content-start`}
    >
      <img
        src={awardImage}
        alt={`AwardImage`}
        className={styles.awardsImage}
      />
      <p  className={`para2 ${styles.description}`}
            dangerouslySetInnerHTML={{ __html: description }}>

      </p>
      
    </div>
  );
};

export default AwardsCard;
